var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('Billable time — only counts while video is flowing')}},[_vm._v(" "+_vm._s(_vm.formattedTime)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }